import { UpdateURL } from "./updateURL";
import $ from "jquery";
import classNames from "classnames";

import { rxhtmltag4jQuery } from "./rxhtmltag";
import { fetchContent, resetXRefPath, changeGuideline, updateOpenSection } from "./counterSlice";
import useTopicFunctions from "../../hooks/useTopicFunctions";
import { updateFavourites } from "../../store/reducers/favourite";
import FavouriteButton from "../../components/FavouriteButton/FavouriteButton";
import { saveFavourite } from "../../components/FavouriteButton/favouritesService";
import { openModal, updateTitle, updateSectionId } from "../openInModal/OpenInModalSlice";
import { isScrollable } from "../../utils/isScrollable";
import { scrollTo } from "../../utils/inpageScroll";
import { findTableSectionId } from "../../hooks/OpenInModalHooks/openInModal";
import { isPregnancyBreastfeedingPage } from "../../utils/pregnancyPageUtils";
import { createUrlFromDitaFilename } from "../../utils/formatters/createUrlFromDitaFilename";

rxhtmltag4jQuery();
//<ContentSection title={cache[filePath].title} content={ditaContent} filePath={filePath} url={location} />

const DEFAULT_FAVOURITE_TOAST_DURATION = 3000;

export function HandleSectionClick(
  dartSelectors,
  updateState,
  topicfile,
  isMobileView = false,
  isModernView = false,
  toast,
  setIsCalculator,
  setCalculatorType,
) {
  const { processFavourite, printDiv } = useTopicFunctions();
  // console.log("HandleSectionClick..bind started");
  let uxTopicContainer = $("#contentId h2.topicontainer");
  uxTopicContainer.off(); // prevent double bind of click event.
  uxTopicContainer.on({
    click: function () {
      if (isModernView) {
        return;
      }
      let selectedTopicPath = $(this).attr("filepath");
      let contentContainer = $(this).closest("section").find(".dartsectiondisplay");
      let contentContainerHeight = contentContainer.outerHeight(true);
      $(contentContainer)
        .css("overflow", "hidden")
        .css("display", "block")
        .css("max-height", "0px");
      if ($(contentContainer).hasClass("active")) {
        // $(contentContainer).css('margin-bottom','-6px');
        // console.log("active",0);
        $(contentContainer).css("max-height", contentContainerHeight + "px");
        setTimeout(() => {
          $(this).find(".fa-angle-up").addClass("fa-angle-down").removeClass("fa-angle-up");
          $(contentContainer).css("max-height", "0px").css("overflow", "hidden");
        }, 0);
        // $(contentContainer).removeClass("active");
      } else {
        // $(contentContainer).css('margin-bottom','-6px');
        // console.log("not active",contentContainerHeight);
        $(contentContainer)
          .css("max-height", "0px")
          .css("overflow", "hidden")
          .css("display", "block");
        setTimeout(() => {
          $(this).find(".fa-angle-down").addClass("fa-angle-up").removeClass("fa-angle-down");
          $(contentContainer).css("overflow", "hidden").css("display", "block");
          $(contentContainer).css("max-height", contentContainerHeight + "px");
        }, 0);
        // $(contentContainer).addClass("active");
      }
      setTimeout(() => {
        UpdateURL(selectedTopicPath, dartSelectors, "H2");
      }, 0);
    },
  });

  let uxArea = $("area");
  uxArea.off();
  uxArea.on({
    // TODO - match linking logic to xref:onclick on countersection
    click: function () {
      let selectedArea = this;
      let matchingHref = $(selectedArea).attr("xref");
      // console.log(matchingHref);
      let matchingXref = $(selectedArea)
        .parent()
        .find('xref[href="' + matchingHref + '"]');
      $(matchingXref).trigger("click");
      // UpdateURL($(selectedArea).attr("xref"),dartSelectors);
      // console.log("areamap clicked");
    },
  });

  let uxFootnote = $("#contentId a[footnote]");
  uxFootnote.off();
  uxFootnote.on({
    click: function (e) {
      let selectedFootnote = this;
      const lastActiveClass = `lastActiveFootNote${$(selectedFootnote).attr("footnote")}`;

      if (!e.target.classList.contains(lastActiveClass)) {
        // Remove hyperlink with same classname
        const anchors = document.querySelectorAll(
          `a[footnote="${$(selectedFootnote).attr("footnote")}"]`,
        );
        anchors.forEach((a) => {
          a.classList.remove(lastActiveClass);
        });
        // Add recently clicked to event triggered footnote
        e.target.classList.add(lastActiveClass);
      }
      let uxfnNote = $('#contentId fn[note="' + $(selectedFootnote).attr("footnote") + '"]');
      uxfnNote.find("i.backToOriginal").addClass("active");

      if (uxfnNote.length > 0) {
        scrollTo(uxfnNote, isMobileView, isModernView);
      }
    },
  });

  let uxDartPrint = $("#contentId .dartprint");
  uxDartPrint.off();
  uxDartPrint.on({
    click: function (e) {
      e.preventDefault();
      let currentElement = this;
      printDiv($(currentElement).attr("href"));
    },
  });

  const appFavourites = $(".appFavourite");
  appFavourites.on({
    click: function (e) {
      if (e.target.classList.contains("tg-icons-Star")) {
        e.target.classList.remove("tg-icons-Star");
        e.target.classList.add("tg-icons-StarFill");
      } else if (e.target.classList.contains("tg-icons-StarFill")) {
        e.target.classList.remove("tg-icons-StarFill");
        e.target.classList.add("tg-icons-Star");
      } else {
        return;
      }
      const added = saveFavourite(
        e.currentTarget.dataset.title,
        e.currentTarget.dataset.url,
        "subtopic",
        e.currentTarget.dataset.topicsection,
        e.currentTarget.dataset.sectionid,
      );
      toast.triggerToast({
        type: "info",
        primaryMessage: added ? "Added to favourites" : "Removed from favourites",
        rightText: isMobileView
          ? '<a href="/app/favourites">View</a>'
          : '<a href="/favourites">View</a>',
        autoHideDuration: DEFAULT_FAVOURITE_TOAST_DURATION,
      });
    },
  });

  document.querySelectorAll("div.tableOpenInFull i.tg-icons-OpenInFull").forEach((icon) => {
    icon.addEventListener("click", function (e) {
      let wrapper = e.target.closest(".tableOpenInFull");
      let ditatitleElement = wrapper?.querySelector("ditatitle");
      let sectionId = findTableSectionId(ditatitleElement);

      if (ditatitleElement) {
        dartSelectors.dispatch(updateSectionId(`table#${sectionId}`));
        dartSelectors.dispatch(updateTitle(ditatitleElement.textContent));
        dartSelectors.dispatch(openModal());
      }
    });
  });

  document.querySelectorAll("div.figureOpenInFull i.tg-icons-OpenInFull").forEach((icon) => {
    icon.addEventListener("click", function (e) {
      let wrapper = e.target.closest(".figureOpenInFull");
      let ditatitleElement = wrapper?.querySelector("ditatitle");
      let sectionId = wrapper?.closest("fig");

      if (ditatitleElement) {
        dartSelectors.dispatch(updateSectionId(`fig#${sectionId.id}`));
        dartSelectors.dispatch(updateTitle(ditatitleElement.textContent));
        dartSelectors.dispatch(openModal());
      }
    });
  });

  document.querySelectorAll("i.backToOriginal").forEach((icon) => {
    icon.addEventListener("click", function (e) {
      const fnEl = e.target.closest("fn");
      const note = fnEl.getAttribute("note");
      const targetEl = document.querySelector(".lastActiveFootNote" + note);
      if (targetEl) {
        scrollTo($(targetEl), isMobileView, isModernView);
      }
    });
  });

  const uxDartFav = $("#contentId .dartfav");
  uxDartFav.off();
  uxDartFav.on({
    click: function (e) {
      e.preventDefault();
      setTimeout(() => {
        const currentElement = this;
        const topicLink = window.location.href.replace(window.location.origin, "");

        const fp = currentElement
          .closest("section")
          .querySelector("h2[filepath]")
          .getAttribute("filepath");
        const filePath = currentElement.getAttribute("id").toLowerCase();

        let topic = currentElement.getAttribute("ditatitle");
        let ditatitle = processFavourite(filePath);
        let transformedFavorite = ditatitle
          .toLowerCase()
          .replace(/\s/g, "")
          .replace(/[^a-zA-Z ]/g, "");

        const addNewFavourite = (favourites, transformedFav, data) => {
          favourites[transformedFav] = data;
          localStorage.setItem("savedFavourites", JSON.stringify(favourites));
          dartSelectors.dispatch(updateFavourites());
          currentElement.classList.add("savedFav");
          alert("Your favourite is added.");
        };

        let savedFavourites = JSON.parse(localStorage.getItem("savedFavourites") || "{}");

        if (!savedFavourites[transformedFavorite]) {
          const data = {
            topic,
            ditatitle: "",
            href: topicLink,
            section: fp,
          };

          addNewFavourite(savedFavourites, transformedFavorite, data);
        } else {
          alert("This section is already in your favourites!");
        }
      }, 500);
    },
  });

  let xrefs = $("xref");
  // Replace all link xrefs with <a> tags to allow them to open in new tab. Onclick will still be applied, to avoid reloading page
  xrefs.each((key, xref) => {
    const isImagemapXref = $(xref).closest("imagemap")?.length ?? false;
    if (isImagemapXref) {
      return; // ignore <xref> with parent <imagemap> as they do not function as standard hyperlinks anyways. changing them breaks the associated area.onclick() listener
    }

    const xrefData = {
      href: xref.attributes["href"]?.value || "",
      format: xref.attributes["format"]?.value,
      scope: xref.attributes["scope"]?.value,
      outputClass: xref.attributes["outputclass"]?.value,
      conkeyref: xref.attributes["conkeyref"]?.value,
      termKeyRef: xref.attributes["keyref"]?.value,
    };

    if (
      !xrefData.href?.includes("/calculator") &&
      !xrefData.href.includes("pbf/") &&
      !xrefData.href.includes("g_") &&
      !xrefData.termKeyRef &&
      !xrefData.conkeyref &&
      !xrefData.scope &&
      !xrefData.format &&
      (!xrefData.outputClass || xrefData.outputClass === "tgl_a")
    ) {
      let formattedhref;
      const queryParams = new URLSearchParams(window.location.search);
      if (xrefData.href.includes("../../")) {
        formattedhref = createUrlFromDitaFilename(xrefData.href);
      } else if (xrefData.href.includes("../")) {
        formattedhref = createUrlFromDitaFilename(
          xrefData.href.replace("..", queryParams.get("guidelinePage")),
        );
      } else {
        formattedhref = createUrlFromDitaFilename(
          queryParams.get("guidelinePage") + "/" + xrefData.href,
        );
      }

      const link = document.createElement("a");
      link.appendChild(xref.childNodes[0]);
      link.setAttribute("unformattedHref", xrefData.href);
      setXrefAttribute(link, "outputClass", xrefData.outputClass);
      link.classList.add("xrefLink");
      link.href = formattedhref;
      link.onclick = xref.onclick;
      xref.replaceWith(link);
    } else if (
      xrefData.scope === "external" &&
      !xrefData.outputClass &&
      xref.style.display !== "none"
    ) {
      const link = document.createElement("a");
      link.appendChild(xref.childNodes[0]);
      link.classList.add("xrefLink");
      link.href = xrefData.href;
      setXrefAttribute(link, "termKeyRef", xrefData.termKeyRef);
      setXrefAttribute(link, "conkeyref", xrefData.conkeyref);
      setXrefAttribute(link, "scope", xrefData.scope);
      setXrefAttribute(link, "format", xrefData.format);
      setXrefAttribute(link, "outputClass", xrefData.outputClass);
      link.onclick = xref.onclick;
      xref.replaceWith(link);
    }
  });

  function setXrefAttribute(link, attribute, value) {
    if (value) {
      link.setAttribute(attribute, value);
    }
  }

  let uxXrefTerm = $("xref,term,.xrefLink");
  uxXrefTerm.off();
  uxXrefTerm.on("click", function (e) {
    e.preventDefault();
    // Extract common data
    // console.log("clicked xref", uxXrefTerm);
    const $xref = $(this);
    const link = $xref.attr("href");

    if (isModernView && link?.includes("/calculator")) {
      setIsCalculator(true);
      const url = new URL(link, "https://app.tg.org.au");

      // Match both /calculator/gfrcalc and /calculator/Gentamicin
      const matchPath = url.pathname.match(/\/calculator\/([a-z0-9_-]+)\b/i);
      const typeFromPath = matchPath?.[1];

      // Also check hash for #lbwcalc etc.
      const matchHash = url.hash.match(/#([a-z0-9_-]+)\b/i);
      const typeFromHash = matchHash?.[1];

      const calculatorType = typeFromPath || typeFromHash;

      if (calculatorType) {
        setCalculatorType(calculatorType.toLowerCase());
      } else {
        console.warn("Unrecognized calculator link:", link);
        setCalculatorType(null);
      }

      return;
    }

    const xrefData = {
      href: $xref.attr("unformattedHref") || $xref.attr("href") || "",
      format: $xref.attr("format"),
      scope: $xref.attr("scope"),
      outputClass: $xref.attr("outputclass"),
      conkeyref: $xref.attr("conkeyref"),
      termKeyRef: $xref.attr("keyref") || "",
      termClosestParag: $xref.closest("p").attr("id") || "",
    };

    // Adjust href path if needed
    xrefData.adjustedHref = xrefData.href.replace("../../" + dartSelectors.ditapath, "");

    // Handle special case: PBF or drug links
    if (xrefData.href.includes("pbf/") || xrefData.termKeyRef.includes("drug")) {
      handlePbfOrDrugLink(xrefData);
      return;
    }

    // Main link type handling
    if (xrefData.conkeyref !== undefined) {
      const [key, id] = xrefData.conkeyref.split("/");
      const referenceContent = $("<body/>").html(
        dartSelectors.cache[dartSelectors.referenceFiles[key]].content,
      );
      const conkeyHref = $(referenceContent).find(`xref[id="${id}"]`).attr("href");
      openLink(conkeyHref);
      return;
    }

    if (xrefData.scope === "external") {
      openLink(xrefData.href);
      return;
    }

    if (xrefData.format && xrefData.format.toLowerCase() === "pdf") {
      let pdfLink = xrefData.href.replace(
        /(\.\.\/){1,}/g,
        "https://ccmsfiles.tg.org.au/" + dartSelectors.ccmsversion.selected + "/",
      );

      if (dartSelectors.uxPlatform === "mobile") {
        if (window.parent.cordova.platformId === "android") {
          window.parent.cordova.InAppBrowser.open(pdfLink, "_system", "location = yes");
        } else {
          window.parent.cordova.InAppBrowser.open(pdfLink, "_blank", "location = yes");
        }
        return;
      }

      const tgPdfViewer = document.querySelector("#tgpdfviewer");
      const tgPDFIframe = document.querySelector("#tgpdfviewer iframe");
      const modalBackdrop = document.querySelector(".modal-backdrop");

      if (!tgPdfViewer.classList.contains("in")) {
        tgPdfViewer.classList.toggle("in");
        tgPDFIframe.src = pdfLink;
        const pdfFileName = pdfLink.includes("/") ? pdfLink.split("/").pop() : pdfLink;

        dartSelectors.iDB.read(pdfFileName).then((value) => {
          if (value) pdfLink = value;
          tgPdfViewer.style.display = "block";
          if (modalBackdrop) {
            modalBackdrop.style.display = "block";
            modalBackdrop.classList.toggle("in");
          }
        });
      }
      return;
    }

    if (xrefData.outputClass === "tgl_a") {
      if (xrefData.href.includes("../../")) {
        dartSelectors.dispatch(changeGuideline({ xrefHref: xrefData.href, dartSelectors }));
      } else if (xrefData.href.includes("../")) {
        UpdateURL(xrefData.href.replace("../", ""), dartSelectors, "", true);
      } else if (xrefData.href.startsWith("#")) {
        scrollToSection(xrefData.href);
      } else {
        UpdateURL(xrefData.href, dartSelectors, "", true);
      }
      return;
    }

    if (xrefData.outputClass === "tgl_preg" || xrefData.outputClass === "tgl_breast") {
      let drugRef = dartSelectors.cache[dartSelectors.referenceFiles.drug_keydef];
      dartSelectors.dispatch(
        resetXRefPath({
          termClosestParag: xrefData.termClosestParag,
          dartSelectors,
        }),
      );

      try {
        if ($("#searcher").val().length > 0) {
          $(".dartsectiondisplay:visible").each(function (index, element) {
            const selectedTopic = $(element)
              .closest(".showtandfsection")
              .find("h2[filepath]")
              .attr("filepath");
            if (selectedTopic !== undefined) {
              dartSelectors.dispatch(updateOpenSection({ selectedTopic, tag: "termKeyRef" }));
            }
          });
        }
      } catch (error) {}

      drugRef = $("<body />").html(drugRef.content);
      const drugHref = $(drugRef).find(`[keys~="${xrefData.termKeyRef}"]`).attr("href");
      const drugKey = "/" + drugHref;

      dartSelectors.dispatch(
        fetchContent({
          guideline: "",
          topicFile: drugKey,
          dartSelectors,
          refContentFile: 1,
        }),
      );

      setTimeout(() => {
        $(".dartmodal").addClass("active");
      }, 1000);
      return;
    }

    if (xrefData.outputClass === "closemodal") {
      $(".dartmodal").toggleClass("active");
      return;
    }

    // Handle remaining cases
    if (xrefData.href.startsWith("#")) {
      scrollToSection(xrefData.href);
    } else if (xrefData.href.indexOf("/") === -1) {
      if (!(xrefData.href.indexOf("g_b_") > -1 || xrefData.href.indexOf("g_p_") > -1)) {
        UpdateURL(xrefData.href, dartSelectors, "", true);
      }
    } else if (xrefData.href.includes("../../")) {
      dartSelectors.dispatch(changeGuideline({ xrefHref: xrefData.href, dartSelectors }));
    } else {
      UpdateURL(xrefData.href, dartSelectors, "", true);
    }
  });

  $("xref,term").addClass("active");

  // Helper functions
  function openLink(url) {
    if (dartSelectors.uxPlatform === "mobile") {
      window.parent.cordova.InAppBrowser.open(url, "_blank", "location = yes");
    } else {
      window.open(url);
    }
  }

  function scrollToSection(href) {
    const localRefID = href.replace(/\//g, " #");
    const $element = $(localRefID);
    const scrollOffset = dartSelectors.uxPlatform === "mobile" ? 100 : 40;

    if (isMobileView) {
      $element[0].scrollIntoView({ block: "start", behavior: "smooth" });
    } else if (isModernView) {
      let container = $("div.topicMainContent");
      if (!isScrollable(container)) {
        container = $("div.webMode");
      }
      const targetTop = $element.offset().top - container.offset().top;
      container.animate(
        {
          scrollTop: targetTop + container.scrollTop() - scrollOffset,
        },
        500,
        "swing",
      );
    } else {
      $("html, body").animate(
        {
          scrollTop: $element.offset().top - scrollOffset,
        },
        500,
        "swing",
      );
    }

    if (dartSelectors.uxPlatform === "mobile") {
      $("body,html").animate(
        {
          scrollTop: $("ion-content", window.parent.top).offset().top - 100,
        },
        500,
        "swing",
      );
    }
  }

  function handlePbfOrDrugLink(xrefData) {
    const modifiedHref = xrefData.adjustedHref.replace(/^(\.\.\/)+/, "");
    const [topicFile, rawSectionId] = modifiedHref.split("/");
    const sectionId = rawSectionId.replace(/\.dita$/, "");

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("guidelinePage", "quicklinks");
    queryParams.set("topicfile", topicFile);
    queryParams.set("guidelinename", "auto");
    queryParams.set("sectionId", sectionId);

    const updatedUrl = `${window.location.pathname}?${queryParams.toString()}#${sectionId}`;

    const stateData = {
      ditaPath: "quicklinks/",
      XRefPath: xrefData.adjustedHref,
      queryString: {
        guidelinePage: "quicklinks/",
        topicfile,
        etgAccess: "true",
      },
      openSection: xrefData.adjustedHref,
      displayBanner: true,
      hashRedirect: true,
    };

    dartSelectors.dispatch(updateState(stateData));
    dartSelectors.navigate(updatedUrl, { replace: false });
  }
}

const IsFilePathInURL = (filePath, url, dartSelectors) => {
  // console.log("dartSelectors>>>",dartSelectors);
  let foundInURL = false;
  // filePath = filePath.split("/").slice(-1)[0].replace(".dita","");

  let fileName = $("#tg_toc_id [tocpath*='" + url + "']").attr("href");
  if (window.location.href.indexOf("viewTopic?") > -1) {
    // MPS path
    fileName = $("#tg_toc_id [mpspath*='" + url + "']")
      .not('[href*=".ditamap"]')
      .attr("href");
  }
  // console.log(fileName==filePath,"fileName:",fileName,"| filePath:",filePath);
  if (fileName === filePath) foundInURL = true;
  url = url.split("/");
  if (url.includes(filePath)) {
    foundInURL = true;
  }

  let findFilePath = [];
  try {
    findFilePath = dartSelectors.openSection.filter((element) => {
      return element === filePath;
    });
  } catch (error) {
    // console.log(error);
  }
  // console.log("findFilePath>>",filePath,findFilePath.length,dartSelectors.openSection);
  if (foundInURL === false) {
    // check state.openSection
    if (findFilePath.length > 0) foundInURL = true;
  } else {
    // foundInURL=false;
    if (findFilePath.length === 0) foundInURL = false;
  }
  return foundInURL;
};

const sectionIcon = (filePath, url, dartSelectors) => {
  let defaultSectionClass = "fa banner-head-topic fa-angle-down";
  if (IsFilePathInURL(filePath, url, dartSelectors)) {
    defaultSectionClass = "fa banner-head-topic fa-angle-up";
  }
  return defaultSectionClass;
};

const sectionDisplay = (filePath, url, dartSelectors, isMobileView, isModernView) => {
  if (isModernView) {
    return "appsectiondisplay";
  }
  let defaultStyle = "dartsectiondisplay";
  if (IsFilePathInURL(filePath, url, dartSelectors)) {
    defaultStyle = "dartsectiondisplay active";
  }
  return defaultStyle;
};

const sectionContentDisplay = (content) => {
  let defaultStyle = "showtandfsection";
  if (content === "") {
    defaultStyle = "hidetandfsection";
  }
  return defaultStyle;
};

const currentClass = (title) => {
  let savedFavourites = localStorage.getItem("savedFavourites");
  if (savedFavourites) {
    savedFavourites = JSON.parse(savedFavourites);

    let topic = title.replace(/ /g, "");
    topic = topic.toLowerCase().replace(/[^a-zA-Z ]/g, "");

    if (savedFavourites[topic]) {
      return "savedFav";
    }
  }

  return "";
};

export const ContentSection = (props) => {
  let notfirst = props.index === 0 ? { display: "none" } : { display: "block" };
  // Check if we're on the pregnancy/breastfeeding page
  const searchParams = new URLSearchParams(window.location.search);
  const pathname = window.location.pathname;
  const isPregnancyPage = isPregnancyBreastfeedingPage(searchParams, pathname);

  return (
    <section
      style={notfirst}
      className={classNames(sectionContentDisplay(props.content), {
        "pregnancy-breastfeeding-section": isPregnancyPage,
      })}
      id={"section-" + props.conceptId}
    >
      {/* <section className={sectionContentDisplay(props.content)}> */}
      <div>
        <h2
          className={classNames(
            "topicontainer",
            { semibold: props.isModernView },
            { appMode: props.isModernView },
            // { modernMode: props.isModernView },
          )}
          filepath={props.filePath}
        >
          {props.title}
          {!props.isModernView && (
            <span className="pull-right">
              <i className={sectionIcon(props.filePath, props.url, props.dartSelectors)}></i>
            </span>
          )}
          {props.isModernView && !isPregnancyPage && (
            <FavouriteButton
              sectionTitle={props.title}
              sectionUrl={props.url}
              type="subtopic"
              topicSection={props.guideline}
              sectionId={props.filePath}
              styling={"appFavourite"}
            ></FavouriteButton>
          )}
        </h2>
      </div>
      <div
        className={classNames(
          "colapsecontent",
          sectionDisplay(
            props.filePath,
            props.url,
            props.dartSelectors,
            props.isMobileView,
            props.isModernView,
          ),
        )}
      >
        {!props.isModernView && (
          <div className="icon-wrapper">
            <ul className="topic-icons text-right showIcon">
              <li
                className={props.dartSelectors.uxPlatform === "mobile" ? "hideprint" : "showprint"}
              >
                <a
                  title="Print section"
                  href={"section-" + props.conceptId}
                  className="print dartprint"
                  data-placement="bottom"
                  data-tooltip="true"
                  data-original-title="Print section"
                >
                  {" "}
                </a>
              </li>
              <li>
                <a
                  className={`favourite dartfav ${currentClass(props.title)}`}
                  data-contentwrapper=".myfavourite"
                  data-placement="bottom"
                  data-tooltip="true"
                  ditatitle={props.title}
                  id={props.title.replace(/ /g, "")}
                  href={"section-" + props.conceptId}
                  title="Add section to favourites"
                  data-original-title="Add section to favourites"
                >
                  {" "}
                </a>
              </li>
            </ul>
          </div>
        )}
        <div className="clearfix"></div>
        <ditacontent dangerouslySetInnerHTML={{ __html: props.content }}></ditacontent>
      </div>
    </section>
  );
};

export const ChildContent = (props) => {
  // console.log("sametitle",props.sameTitle);
  let sameTitleStyle = props.sameTitle ? { display: "none" } : { display: "block" };
  const LevelHeader = `h${props.level - 1}`;
  return (
    <section className={sectionContentDisplay(props.content)}>
      <div>
        <LevelHeader
          filepath={props.filePath}
          style={sameTitleStyle}
          className={sectionDisplay(
            props.filePath,
            props.url,
            props.dartSelectors,
            props.isMobileView,
            props.isModernView,
          )}
        >
          {props.title}
        </LevelHeader>
      </div>
      <ditacontent dangerouslySetInnerHTML={{ __html: props.content }}></ditacontent>
    </section>
  );
};
